import { render, staticRenderFns } from "./new_task.vue?vue&type=template&id=3cad11d2&scoped=true"
import script from "./new_task.vue?vue&type=script&lang=js"
export * from "./new_task.vue?vue&type=script&lang=js"
import style0 from "./new_task.vue?vue&type=style&index=0&id=3cad11d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cad11d2",
  null
  
)

export default component.exports